import {NavLink} from "react-router-dom";
import React from "react";
import {useSelector} from "react-redux";
import PropTypes from "prop-types";

const PermNavLink = ({ to, activeClassName, className, children }) => {
    const {permissions} = useSelector(state => state.auth);

    return (permissions && permissions.find(item => item === to.replace(/\//g, '')) ?
        <NavLink to={to} className={className} activeClassName={activeClassName}>
            {children}
        </NavLink> : ''
    )
};

PermNavLink.propTypes = {
    to: PropTypes.string,
    activeClassName: PropTypes.string,
    className: PropTypes.string,
    children: PropTypes.node
};

export default PermNavLink;